import React from 'react';
import { useTranslation } from 'react-i18next';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { BannerLayout, BannerMessage, BannerButton } from '@wix/da-ds/pkg/Banner/lego';
import CloseIcon from '@wix/da-ds/pkg/Icons/16x16/Close';
import { usePWABanner } from './usePWABanner';
import s from './PWABanner.scss';
const PWABanner = ()=>{
    const { t } = useTranslation();
    const { dismiss, registerPushSubscription, isSubscribed, isHidden } = usePWABanner();
    if (isHidden || isSubscribed) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(BannerLayout, {
        size: "big",
        className: s['root'],
        body: [
            /*#__PURE__*/ React.createElement(IconButton, {
                icon: CloseIcon,
                "aria-label": t('common.close'),
                key: "midfix-icon",
                size: "small",
                iconClassName: s['icon'],
                onClick: dismiss
            }),
            /*#__PURE__*/ React.createElement(BannerMessage, {
                key: "message-after-icon",
                weight: "bld",
                className: s['your-typography-colors']
            }, /*#__PURE__*/ React.createElement("div", {
                className: s['title']
            }, t('pwa.banner.title')), /*#__PURE__*/ React.createElement("div", {
                className: s['subtitle']
            }, t('pwa.banner.subtitle')))
        ],
        postfix: /*#__PURE__*/ React.createElement(BannerButton, {
            variant: "solid",
            onClick: registerPushSubscription
        }, t('pwa.confirmationPopup.button.cta'))
    });
};
PWABanner.displayName = 'PWABanner';
export default PWABanner;

//# sourceMappingURL=PWABanner.js.map